// clearance-defaults.js
// Shared clearance input defaults (in meters)

// Standard heavy vehicle dimensional defaults (in meters)
import { unitClearanceDefaults } from '../../modules/trailer-clearance/src/factories/constants.mjs';

export const clearanceDefaults = unitClearanceDefaults;
